export default __webpack_public_path__ + "static/media/magnifying-glass-icon.5656968e.svg";